/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPartialYesNoEnum } from './CRSFSecReviewPartialYesNoEnum';
import {
    CRSFSecReviewPartialYesNoEnumFromJSON,
    CRSFSecReviewPartialYesNoEnumFromJSONTyped,
    CRSFSecReviewPartialYesNoEnumToJSON,
} from './CRSFSecReviewPartialYesNoEnum';

/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyPolicyAnalysisExternalResult
 */
export interface CRSFSecReviewPrivacyPolicyAnalysisExternalResult {
    /**
     * 
     * @type {CRSFSecReviewPartialYesNoEnum}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    advanced_privacy_controls?: CRSFSecReviewPartialYesNoEnum;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    contact_address?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    contact_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    last_updated?: string;
    /**
     * 
     * @type {CRSFSecReviewPartialYesNoEnum}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    mention_of_childrens_data?: CRSFSecReviewPartialYesNoEnum;
    /**
     * 
     * @type {CRSFSecReviewPartialYesNoEnum}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    mention_of_generic_tracking_technologies?: CRSFSecReviewPartialYesNoEnum;
    /**
     * 
     * @type {CRSFSecReviewPartialYesNoEnum}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    mention_of_opt_out?: CRSFSecReviewPartialYesNoEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewPrivacyPolicyAnalysisExternalResult
     */
    specific_tracking_technologies?: Array<string>;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyPolicyAnalysisExternalResult interface.
 */
export function instanceOfCRSFSecReviewPrivacyPolicyAnalysisExternalResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSON(json: any): CRSFSecReviewPrivacyPolicyAnalysisExternalResult {
    return CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyPolicyAnalysisExternalResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advanced_privacy_controls': !exists(json, 'advanced_privacy_controls') ? undefined : CRSFSecReviewPartialYesNoEnumFromJSON(json['advanced_privacy_controls']),
        'contact_address': !exists(json, 'contact_address') ? undefined : json['contact_address'],
        'contact_email': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'contact_phone': !exists(json, 'contact_phone') ? undefined : json['contact_phone'],
        'last_updated': !exists(json, 'last_updated') ? undefined : json['last_updated'],
        'mention_of_childrens_data': !exists(json, 'mention_of_childrens_data') ? undefined : CRSFSecReviewPartialYesNoEnumFromJSON(json['mention_of_childrens_data']),
        'mention_of_generic_tracking_technologies': !exists(json, 'mention_of_generic_tracking_technologies') ? undefined : CRSFSecReviewPartialYesNoEnumFromJSON(json['mention_of_generic_tracking_technologies']),
        'mention_of_opt_out': !exists(json, 'mention_of_opt_out') ? undefined : CRSFSecReviewPartialYesNoEnumFromJSON(json['mention_of_opt_out']),
        'specific_tracking_technologies': !exists(json, 'specific_tracking_technologies') ? undefined : json['specific_tracking_technologies'],
    };
}

export function CRSFSecReviewPrivacyPolicyAnalysisExternalResultToJSON(value?: CRSFSecReviewPrivacyPolicyAnalysisExternalResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advanced_privacy_controls': CRSFSecReviewPartialYesNoEnumToJSON(value.advanced_privacy_controls),
        'contact_address': value.contact_address,
        'contact_email': value.contact_email,
        'contact_phone': value.contact_phone,
        'last_updated': value.last_updated,
        'mention_of_childrens_data': CRSFSecReviewPartialYesNoEnumToJSON(value.mention_of_childrens_data),
        'mention_of_generic_tracking_technologies': CRSFSecReviewPartialYesNoEnumToJSON(value.mention_of_generic_tracking_technologies),
        'mention_of_opt_out': CRSFSecReviewPartialYesNoEnumToJSON(value.mention_of_opt_out),
        'specific_tracking_technologies': value.specific_tracking_technologies,
    };
}

